export const EXTERNAL_SCRIPT_ID = "devlink-components-external-script";
export const SCRIPT_TAG = "script";
export const EXTERNAL_SCRIPT_SRC = process.env.DEVLINK_SCRIPT_SRC;
